import {Completable, LoanSummaryDTO, pending, UnderwritingContext} from 'kashable-mobile-common';

import {getLoanDetails as fetchLoanDetailsRequest} from '../apis/application';
import {RootState} from '../store';

import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

export type LoanDetailsValues = {
    t: number;
    k: number;
    u: UnderwritingContext;
};

const INITIAL_STATE: Completable<LoanSummaryDTO> = pending();

export const fetchLoanDetails = createAsyncThunk(
    'loanDetails/fetch',
    async (loanDetails: LoanDetailsValues, {rejectWithValue}) => {
        const response = await fetchLoanDetailsRequest(loanDetails.t, loanDetails.k, loanDetails.u);
        if (response.error) {
            rejectWithValue(response);
        }

        return response;
    },
);

export const loanDetailsSlice = createSlice({
    name: 'loanDetails',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearLoanDetails: () => {
            return {...INITIAL_STATE};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLoanDetails.pending, () => {
                return pending();
            })
            .addCase(fetchLoanDetails.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const {
    clearLoanDetails
} = loanDetailsSlice.actions;

export const selectLoanDetails = (state: RootState) => state.loanDetails;
export default loanDetailsSlice.reducer;
